import { LocationQueryValue } from 'vue-router'

type QueryValue = LocationQueryValue | LocationQueryValue[] | undefined

export function parseStayTrail(raw: QueryValue): string[] {
  if (raw === null || raw === undefined) {
    return []
  }
  const values = Array.isArray(raw) ? raw : [raw]

  return values.filter((iep): iep is string => typeof iep === 'string' && iep.length > 0)
}

export function serializeStayTrail(trail: string[]): string[] | undefined {
  return trail.length > 0 ? trail : undefined
}

export function nextStayTrail(currentTrail: QueryValue, currentStayLabel: QueryValue): string[] | undefined {
  const trail = parseStayTrail(currentTrail)
  if (typeof currentStayLabel === 'string' && currentStayLabel.length > 0) {
    trail.push(currentStayLabel)
  }

  return serializeStayTrail(trail)
}
